/* eslint-disable */
export default {
  _cup_stack_instructions: 'cup-stack-instructions',
  _cup_stacking_title: 'cup-stacking-title',
  _great_job: 'great-job',
}